import Checkbox from '@mui/material/Checkbox';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircleUnchecked from '@mui/icons-material/RadioButtonUnchecked';
import ErrorIcon from '@mui/icons-material/Error';

import React, { Component } from 'react';

export class CheckBoxControl extends Component {
    render() {
        const { checked, missing } = this.props;
        return (
            <Checkbox
                checked={checked}
                icon={
                    <CircleUnchecked
                        style={{
                            width: '20px',
                            height: '20px',
                        }}
                    />
                }
                checkedIcon={
                    missing ? (
                        <ErrorIcon
                            style={{
                                color: '#EA3219',
                                width: '20px',
                                height: '20px',
                            }}
                        />
                    ) : (
                        <CheckCircleIcon
                            style={{
                                color: '#009639',
                                width: '20px',
                                height: '20px',
                            }}
                        />
                    )
                }
                disableRipple
            />
        );
    }
}

export default CheckBoxControl;
